import { env } from 'next-runtime-env';

import type { Tenant } from '@core/Entities/App/Tenants.entity';
import type { Locale } from '@core/Entities/Locale/Locale.entity';

// Kentico is being decommissioned in favour of Umbraco. This is a hollowed-out shell —
// it no longer calls the real Kentico API — retained only so the identifiers it was
// fetching aren't lost for when its callers are migrated off Kentico.
export const getKenticoContent = async <T extends Record<string, any>>(
  identifier: string,
  depthParameter = 1,
  locale: Locale,
  tenant?: Tenant,
  isContentType = false,
): Promise<T | T[] | null> => {
  const codename = tenant ? `${tenant}_${identifier}` : identifier;

  if (env('NEXT_PUBLIC_APP_ENV') === 'local') {
    console.error(
      `Error: attempt to fetch Kentico data ${
        isContentType ? 'type' : 'page'
      }=${codename} depthParameter=${depthParameter} locale=uk`,
    );
  }

  return null;
};
